module.exports = __webpack_public_path__ + "img/资源 62 (2).c28395ba.png";